export function getBaseURL() {
  return 'https://api.promptboom.com'
}
